import { render, staticRenderFns } from "./FlashcardStarter.vue?vue&type=template&id=56db9acd&scoped=true&"
import script from "./FlashcardStarter.vue?vue&type=script&lang=js&"
export * from "./FlashcardStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db9acd",
  null
  
)

export default component.exports